
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.534 3.56c.062-.44.252-1.165.842-1.195H7.5c.889 0 .868 1.524.868 1.524v.357c.986-1.028 2.785-2.907 3.015-3.17.321-.367.914.136.914.136L8.642 5.005l-.268.032c.003.301.006.646.013 1.013a543.82 543.82 0 013.362 3.204c.32.32-.137.959-.137.959L8.408 7.125l.003.066c.042 1.651-.594 1.906-.594 1.906l-.042.211v1.947H8.96c.212 0 .212.085.212.085l-.084.889-.085-.338H7.775v2.159l-.085.254-.254.168v-.168l-.21-.424V11.85H5.997l-.085.337-.085-.888s0-.085.212-.085h1.185l-.042-1.947-.042-.212s-.636-.254-.636-1.863v-.659c-1 1.044-2.71 2.83-2.934 3.088-.229.273-.868-.183-.868-.183l3.654-3.792.148-.019V4.543C5.492 3.58 3.489 1.678 3.25 1.44c-.32-.32.138-.914.138-.914L6.534 3.56z"}})])
          )
        }
      }
    